import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Logo from "../../../components/logo/Logo";
import SocialLogin from "../../../components/socialLogin/SocialLogin";
import { Modal } from "react-bootstrap";
import Input from "../../../components/common/Input";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import { handleShowPassword, validateEmail } from "../../../utils";
import { invalidAccess } from "../../../utils";
import "./index.scss";
import { SET_LOGIN_USER_SUCCESS } from "../../../store/actions/loginActions";
import { OnLogin, OnSocialLogin } from "./queries";
import LeftBase from "../../../components/common/LeftBase";
import active_eye from "../../../svg/active-eye.svg";
import eye_closed from "../../../svg/eye-closed.svg";
import active_email from "../../../svg/active-email.svg";
import active_lock from "../../../svg/active-lock.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import loginFooter from "../../../assets/assets_html/images/login-footer-icon.png";
import disable_email from "../../../svg/disable-email.svg";
import VikramshilaLogo from "../../../assets/img/logos/logo_full_org.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import Divider from "../../../components/common/Divider";
import FormModal from "../../../components/Modal/formModal";
import { OnForgotPassword } from "../forgotpassword/queries";
import SuccessModal from "../../../components/Modal/sucessModal";
import { OnResendOtp, VerifyVendorEmail } from "../verifyEmail/queries";
import VerifyOtp from "../verifyotp";
import Checkbox from "../../../components/common/Checkbox";
import verifiedIcon from "../../../svg/verifiedCheck.svg";
import "./../../../components/common/index.scss";
import { Helmet } from "react-helmet";
import AakashgangaHeader from "../../../components/global/HeaderComponent";
export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState({});
  const [registeredModal, setRegisteredModal] = useState({
    show: false,
    published: false,
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [otp, setOtp] = useState();
  const [mobileOtp, setMobileotp] = useState();
  const [userId, setUserId] = useState();
  const [VerifyPopupOpen, setVerifyPopupOpen] = useState(false);
  const [VerifyMobilePopupOpen, setVerifyMobilePopupOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [userNationality, setUserNationality] = useState({});
  const [loginCredentials, setLoginCredentials] = useState({});
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    signupForUpdates: false,
  });
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(true);
  const dispatch = useDispatch();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Accessing UTM parameters
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");
  const utmContent = searchParams.get("utm_content");

  const socialSucessHandler = (success) => {
    if (success?.data?.isSetupProfile) {
      localStorage.setItem("usertoken", success.data?.token);
      storeSessionTime();
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: success?.data,
      });
      navigate("/");
      return null;
    } else if (!success?.data?.isSetupProfile) {
      setErrorMsg("");
      localStorage.setItem("usertoken", success.data?.token);
      storeSessionTime();
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: success?.data,
      });
      return null;
    } else {
      setRegisteredModal({
        show: true,
        published: success?.data?.isSetupProfile ? true : false,
      });
    }
  };

  const EmailsucessHandler = (sucess) => {
    setErrorMsg("");
    setVerifyPopupOpen(false);
    // setVerifyMobilePopupOpen(true);
    setSuccessModalOpen(true);
  };

  const handleHome = (e) => {
    e.preventDefault();
    navigate(registeredModal.published ? "/" : "/login");
    setRegisteredModal({ show: false, published: false });
  };

  const handleRedirectVideo = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const handleHide = (e) => {
    setRegisteredModal({ show: false, published: false });
  };

  const MobilesucessHandler = (sucess) => {
    setErrorMsg("");
    setMobileotp("");
    setOtp();
    setVerifyMobilePopupOpen(false);
    setVerifyPopupOpen(true); //latest code added
    // setSuccessModalOpen(true);
    // window.location.reload()
  };

  const handleVerifyEmailSubmit = (e) => {
    e.preventDefault();
    const headers = {
      otp: otp,
      userId: userId,
    };
    verifyEmail(headers);
  };

  const handleVerifyMobileSubmit = (e) => {
    e.preventDefault();
    const headers = {
      otpForMobileVerification: mobileOtp,
      userId: userId,
    };
    verifyMobile(headers);
  };

  const resendOtpSucess = (sucess) => {
    setErrorMsg("");
    if (sucess?.data?.otpformobileverification) {
      // setMobileotp(sucess?.data?.otpformobileverification);
      setMobileotp("");
    }
  };
  const handleRensedOtp = (e, type) => {
    e.preventDefault();
    if (type === "email") {
      let param = {
        email: email,
      };
      resedOtp(param);
    } else {
      let param = {
        phoneNumber: mobileNumber,
      };
      resedOtp(param);
    }
  };

  //new code
  const { mutate: socialLogin } = OnSocialLogin(socialSucessHandler);

  const handleSocialLogin = (result) => {
    const data = result?.user;
    const apiBody = {
      fullName: data?.displayName,
      email:
        result?.providerId === "twitter.com"
          ? result?.["_tokenResponse"]?.email
          : data?.email,
      rawId: data?.uid,
      isSocialLogin: true,
      signupForUpdates: checkboxes?.signupForUpdates,
      utmSource: utmSource,
      utmMedium: utmMedium,
      utmCampaign: utmCampaign,
      utmContent: utmContent,
    };
    socialLogin(apiBody);
  };
  const sucessHandler = (auth) => {
    const {
      emailVerified,
      mobileVerified,
      email,
      phoneNumber,
      _id,
      isSetupProfile,
      nationality,
    } = auth?.data?.data;
    setUserData(auth?.data);
    setUserNationality(nationality);
    setMobileNumber(phoneNumber);
    setEmail(email);
    setUserId(_id);
    setErrorMsg("");
    // setMobileotp(auth.data?.otpForMobile);
    setMobileotp("");
    if (isSetupProfile) {
      localStorage.setItem("usertoken", auth.data?.token);
      // localStorage.setItem(
      //   "societyData",
      //   JSON.stringify(auth?.data?.SocietyJournal),
      // );
      storeSessionTime();
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: auth?.data,
      });
      navigate("/");
      return null;
    } else if (emailVerified && mobileVerified) {
      localStorage.setItem("usertoken", auth.data?.token);
      storeSessionTime();
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: auth?.data,
      });
    }

    // latest code commented
    else if (!mobileVerified) {
      setVerifyMobilePopupOpen(true);
    } else if (!emailVerified) {
      setVerifyPopupOpen(true);
    }
  };

  const { mutate: resedOtp } = OnResendOtp(resendOtpSucess, setErrorMsg);
  const { mutate: verifyEmail } = VerifyVendorEmail(
    EmailsucessHandler,
    setErrorMsg,
  );
  const { mutate: verifyMobile } = VerifyVendorEmail(
    MobilesucessHandler,
    setErrorMsg,
  );

  const { mutate: login } = OnLogin(sucessHandler, setErrorMsg);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...loginCredentials,
      signupForUpdates: checkboxes?.signupForUpdates,
    };
    login(payload);
  };

  const [email, setEmail] = useState();
  const [disabledModalSubmit, setDisabledModalSubmit] = useState(true);
  const sucessHandlerForgotPassword = (forgotSucess) => {
    setErrorMsg("");
    setForgotPasswordOpen(false);
    setEmail("");
    return setResetSend(true);
  };
  const handleSubmitForgotPassword = (e) => {
    const data = { email: email, frontendBaseUrl: window.location.origin };
    forgotPassword(data);
  };
  const { mutate: forgotPassword } = OnForgotPassword(
    sucessHandlerForgotPassword,
    setErrorMsg,
  );

  const [showResetSend, setResetSend] = useState(false);
  useEffect(() => {
    setDisabled(!validateEmail(email));
    // eslint-disable-next-line
  }, [email]);

  if (!utmSource) {
    var allutm = "";
  } else {
    var allutm = `?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_content=${utmContent}`;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginCredentials({
      ...loginCredentials,
      [name]: invalidAccess(value),
      utmSource: utmSource,
      utmMedium: utmMedium,
      utmCampaign: utmCampaign,
      utmContent: utmContent,
    });
  };

  const openForgotPassword = () => {
    setErrorMsg("");
    setForgotPasswordOpen(true);
  };
  const handleSucessModalSubmit = () => {
    setSuccessModalOpen(false);
    storeSessionTime();
    localStorage.setItem("usertoken", userData?.token);
    dispatch({
      type: SET_LOGIN_USER_SUCCESS,
      payload: userData,
    });
  };

  const handleChatBot = (e) => {
    e.preventDefault();
    window.zE("messenger", "open");
  };

  useEffect(() => {
    setDisabled(
      !(validateEmail(loginCredentials?.email) && loginCredentials?.password),
    );
  }, [loginCredentials]);
  useEffect(() => {
    storeSessionTime();
    setDisabledModalSubmit(!validateEmail(email));
  }, [email]);
  const handleClickCheckbox = (e, type) => {
    const { name, checked } = e.target;
    if (type) {
      setCheckboxes({
        ...checkboxes,
        [type]: { ...checkboxes[type], [name]: checked },
      });
      return null;
    }
    return setCheckboxes({ ...checkboxes, [name]: checked });
  };

  function storeSessionTime() {
    const addedMin = 420;
    const miliseconds = new Date().getTime() + addedMin * 60000;
    localStorage.setItem("tokenExpireTime", miliseconds);
  }

  return (
    <>
      <AakashgangaHeader />
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="container-flex login-page">
        <div className="row h-100">
          <div className="col-lg-5 col-xl-5 d-none d-lg-block left-base position-relative">
            <LeftBase type="Login" />
          </div>
          <div className="col-lg-7 col-xl-7 col-md-12 col-sm-12 m-auto login-form-column">
            <div className="p-3">
              <div className="login-form-container">
                <div className="login-header text-start">
                  <h1 className="login-title">Login</h1>
                  <p className="login-subtitle" style={{ color: "#000000" }}>
                    Don’t have an account?{" "}
                    <Link
                      to={`/registration${allutm}`}
                      className="register-link"
                    >
                      REGISTER NOW
                    </Link>
                  </p>
                </div>

                <Form onSubmit={handleSubmit} className="mt-4">
                  <Input
                    name="email"
                    className={
                      loginCredentials?.email
                        ? "form-control active-input with_icon"
                        : "form-control grey-input with_icon"
                    }
                    handleChange={handleChange}
                    type="email"
                    preIconClass={
                      loginCredentials?.email ? active_email : disable_email
                    }
                    labelClass=""
                    label="Email ID"
                    placeholder="johndoe@gmail.com"
                    value={loginCredentials.email}
                    mandatory={true}
                  />
                  <Input
                    errors={errorMsg}
                    name="password"
                    handleChange={handleChange}
                    className={
                      loginCredentials?.password
                        ? "form-control active-input with_icon mt-2"
                        : "form-control grey-input with_icon mt-2"
                    }
                    type={!showPassword ? "password" : "text"}
                    labelClass=""
                    preIconClass={
                      loginCredentials?.password ? active_lock : disable_lock
                    }
                    postIconClass={
                      loginCredentials?.password
                        ? showPassword
                          ? eye_closed
                          : active_eye
                        : showPassword
                          ? eye_closed
                          : disable_eye
                    }
                    value={loginCredentials.password}
                    label="Password"
                    placeholder="*******************"
                    onIconClick={() =>
                      handleShowPassword(setShowPassword, showPassword)
                    }
                    mandatory={true}
                  />
                  <div className="d-flex justify-content-between align-items-center mt-1 mb-4">
                    <div className="d-flex align-items-center gap-1">
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "700",
                        }}
                        className="mandatory-asterisk"
                      >
                        *
                      </span>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          marginBottom: "10px",
                          fontFamily: "Montserrat",
                        }}
                      >
                        Mandatory
                      </p>
                    </div>
                    <Link
                      to="#"
                      onClick={() => openForgotPassword()}
                      className="forgot-password-link"
                      style={{
                        color: "#006f92",
                        fontWeight: "600",
                        fontFamily: "Montserrat",
                      }}
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="checkbox-section mt-3">
                    <div className="d-flex align-items-start mb-2">
                      <Checkbox
                        name="signupForUpdates"
                        checked={checkboxes?.signupForUpdates}
                        className="form-check-input me-2 mt-2"
                        onRadioChange={handleClickCheckbox}
                        style={{ width: "25px", height: "25px" }}
                      />
                      <div>
                        <span
                          className="stay-logged-in mt-2"
                          style={{ color: "#000000", fontSize: "16px" }}
                        >
                          Stay logged in (not recommended on shared devices).
                        </span>
                      </div>
                    </div>
                    <p
                      className="stay-logged-in"
                      style={{
                        width: "530px",
                        fontSize: "16px",
                        color: "#000000",
                      }}
                    >
                      <i>
                        For security, long inactivity will log you out
                        automatically.
                      </i>
                    </p>
                  </div>

                  <div className="mt-5 text-center">
                    <Button
                      type="submit"
                      title="Start Publishing"
                      disabled={disabled}
                    />
                  </div>
                  <div
                    style={{
                      position: "fixed",
                      bottom: "50px",
                      right: "50px",
                    }}
                  >
                    <img src={loginFooter} alt="login" />
                  </div>
                </Form>
                <div className="mx-25 d-none">
                  <Divider />
                </div>
                <div className="social-login-section d-none">
                  <SocialLogin handleSocialLogin={handleSocialLogin} />
                </div>
              </div>
            </div>

            {/* <div class="row align-items-center justify-content-between contentFooter pt-3">
              <div class="col text-end">
                <a onClick={handleChatBot} class="helpLink">
                  <b class="icon-help"></b>Help
                </a>
              </div>
            </div> */}
          </div>
        </div>
        {/* <FormModal
          show={VerifyPopupOpen}
          handleClose={(e) => setVerifyPopupOpen(false)}
          informationText="Please enter the OTP sent to your email ID"
          modalHeading="Verify Email ID"
        >
          <VerifyOtp
            errorMsg={errorMsg}
            handleRensedOtp={handleRensedOtp}
            otp={otp}
            setOtp={setOtp}
            handleSubmit={handleVerifyEmailSubmit}
            type="email"
          />
        </FormModal> */}
        {userNationality === "withInIndia" ? (
          <FormModal
            handleClose={(e) => setVerifyMobilePopupOpen(false)}
            show={VerifyMobilePopupOpen}
            // upperInformationText={`Your Email ID has been successfully verified <img src=${verifiedIcon} alt='email' className='mx-1' />`}
            // lowerInformationText="Please enter the OTP sent to your mobile number."
            informationText="Please enter the OTP sent to your mobile number"
            modalHeading="Verify Mobile Number"
          >
            {/* <img src={verifiedIcon} alt="email" className="mx-1" /> */}
            <VerifyOtp
              errorMsg={errorMsg}
              handleRensedOtp={handleRensedOtp}
              otp={mobileOtp}
              setOtp={setMobileotp}
              handleSubmit={handleVerifyMobileSubmit}
              type="mobile"
            />
          </FormModal>
        ) : null}

        <Modal
          show={registeredModal.show}
          onHide={handleHide}
          className="re-register justify-content-center pb-3 px-0 pt-0"
          centered
        >
          <Modal.Header className="justify-content-center px-0 pt-0">
            <Modal.Title className="mt-2">
              <div className="big-heading error-title">
                YOU ARE ALREADY REGISTERED
              </div>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              onClick={(e) => handleHide()}
              aria-label="Close"
            />
          </Modal.Header>

          <div
            className="text-center label-info color-black"
            dangerouslySetInnerHTML={{
              __html: "We will get in touch with you soon...",
            }}
          />
          <div
            className="text-center label-info mt-3 f-size-16 color-black"
            dangerouslySetInnerHTML={{
              __html: "Till then, we welcome you to listen to",
            }}
          />

          <Modal.Footer className="justify-content-center d-grid">
            <Button
              handleClick={(e) => handleRedirectVideo(e, "/browse")}
              title="MESSAGE FROM THE FOUNDER"
              type="button"
            />
            <div className="text-center">
              <a
                onClick={(e) => handleHome(e)}
                href="/"
                className="link text-decoration-none f-700"
              >
                {registeredModal.published
                  ? "Home"
                  : "Continue Building Your Profile"}
              </a>
            </div>
          </Modal.Footer>
        </Modal>

        {/* <FormModal
          handleClose={(e) => setVerifyMobilePopupOpen(false)}
          show={VerifyMobilePopupOpen}
          upperInformationText={`Your Email ID has been successfully verified <img src=${verifiedIcon} alt='email' className='mx-1' />`}
          lowerInformationText="Please enter the OTP sent to your mobile number."
          modalHeading="Verify Mobile Number"
        > */}
        {/* <img src={verifiedIcon} alt="email" className="mx-1" /> */}
        {/* <VerifyOtp
            errorMsg={errorMsg}
            handleRensedOtp={handleRensedOtp}
            otp={mobileOtp}
            setOtp={setMobileotp}
            handleSubmit={handleVerifyMobileSubmit}
            type="mobile"
          />
        </FormModal> */}

        {userNationality === "withInIndia" ? (
          <FormModal
            show={VerifyPopupOpen}
            handleClose={(e) => setVerifyPopupOpen(false)}
            // informationText="Please enter the OTP sent to your email ID"
            upperInformationText={`Your mobile number has been successfully verified <img src=${verifiedIcon} alt="mobile" class="mx-1 mb-1" />`}
            lowerInformationText="Please enter the OTP sent to your email ID"
            modalHeading="Verify Email ID"
          >
            <VerifyOtp
              errorMsg={errorMsg}
              handleRensedOtp={handleRensedOtp}
              otp={otp}
              setOtp={setOtp}
              handleSubmit={handleVerifyEmailSubmit}
              type="email"
            />
          </FormModal>
        ) : (
          <FormModal
            show={VerifyPopupOpen}
            handleClose={(e) => setVerifyPopupOpen(false)}
            // informationText="Please enter the OTP sent to your email ID"
            // upperInformationText={`Your mobile number has been successfully verified <img src=${verifiedIcon} alt="mobile" class="mx-1 mb-1" />`}
            lowerInformationText="Please enter the OTP sent to your email ID"
            modalHeading="Verify Email ID"
          >
            <VerifyOtp
              errorMsg={errorMsg}
              handleRensedOtp={handleRensedOtp}
              otp={otp}
              setOtp={setOtp}
              handleSubmit={handleVerifyEmailSubmit}
              type="email"
            />
          </FormModal>
        )}

        <FormModal
          upperInformationText="Let us help you set it up right away"
          lowerInformationText="Enter your email below to receive the reset link"
          show={forgotPasswordOpen}
          modalHeading="Forgot Password"
          onSubmit={handleSubmitForgotPassword}
          submitButtonTitle="Submit"
          closebutton={true}
          disabled={disabledModalSubmit}
          handleClose={() => {
            setForgotPasswordOpen(false);
            setErrorMsg("");
          }}
        >
          <Input
            name="email"
            className={
              email
                ? `form-control active-input with_icon_forgot mt-2 ${
                    errorMsg && "error-border"
                  }`
                : "form-control grey-input with_icon_forgot"
            }
            type="email"
            errors={errorMsg}
            preIconClass={email ? active_email : disable_email}
            labelClass={email ? "label" : "hidden label"}
            label="Email ID"
            placeholder="Email ID"
            value={email}
            handleChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </FormModal>

        <SuccessModal
          modalHeading="Password Reset Link Sent"
          upperInformationText="A link has been sent to your registered email id. Please follow the instructions."
          show={showResetSend}
          submitButtonTitle={"Close"}
          onSubmit={(e) => setResetSend(false)}
        />

        <SuccessModal
          bigHeading="CONGRATULATIONS"
          upperInformationText={
            userNationality === "withInIndia"
              ? `Mobile number verified <img src=${verifiedIcon} alt="email" className="mx-1" /> Email ID verified <img src=${verifiedIcon} alt="email" className="mx-1" />`
              : `Email ID verified <img src=${verifiedIcon} alt="email" className="mx-1" />`
          }
          lowerInformationText="Please set up your profile to continue"
          show={successModalOpen}
          submitButtonTitle="STEP INTO GREATNESS"
          onSubmit={() => handleSucessModalSubmit()}
        />
      </div>
    </>
  );
}
